<template>
  <div>
    <form class="login" @submit.prevent="login">
      <h1>Sign In</h1>
      <label>Email</label><br/>
      <input required v-model="email" type="text" placeholder="email"/><br/>
      <label>Password</label><br/>
      <input required v-model="password" type="password" placeholder="password"/><br/>
      <button type="submit">Login</button>
    </form>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'LoginPage',
  props: {},
  data: () => ({
    data: [],
    baseURL: 'https://crossover-api-dot-elite-pointer-290612.uc.r.appspot.com',
    email: '',
    password: ''
  }),
  methods: {
    login: function () {
      axios.defaults.headers.common = {
        "Authorization": "Basic " + btoa(this.email + ":" + this.password)
      };

      axios.post(`${this.baseURL}/api/signin`)
          .then(res => {
            localStorage.setItem("userId", res.data['id']);

            this.$router.push('/listings').catch(failure => {
              console.log(failure);
            });
          }).catch(fail => console.log(fail));
    }
  }
}
</script>